import {
  GET_PEDIDOS,
  GET_PEDIDO,
  GET_PEDIDOS_ADMIN,
  GET_PEDIDO_ADMIN,
  GET_METODOS_ENVIO,
  GET_METODO_ADMIN,
  ENVIA_METODO,
  GET_METODOS_ENVIO_ADMIN
} from "../actions";

import { 
  PEDIDO_UPDATE_STAT,
  BORRA_METODO
} from "../actions/admin";


import {fromJS,mergeDeep,merge} from 'immutable';

const initialProductos = {
  pedidos:[], 
  pedidoCont:[],
  metodos_envio:[],
  metodos_envio_admin:[],
  metodo_envio: null,
  pedido: null,
  inAction: false,
  contador:0
}

const pedidos = (state=initialProductos, action) => {
  
  const estadoNuevo = Object.assign({}, state);
  const datosNuevo = fromJS(estadoNuevo)

  switch (action.type) {

    case GET_PEDIDOS:
      var pedidos_temp=[]
      action.pedidos.forEach(function(doc) {
        var data_temp=doc.data()
        data_temp['id']=doc.id
        pedidos_temp.push(data_temp)
      });
      const pedidosNew = datosNuevo.updateIn(['pedidos'],value => pedidos_temp)
      return pedidosNew.toJSON()

    case GET_PEDIDO:
      console.log(action.pedidoCont)
      var pedidocont_temp=[]
      action.pedidoCont.forEach(function(doc) {
        var data_temp=doc.data()
        data_temp['id']=doc.id
        pedidocont_temp.push(data_temp)
      });
      var pedido_temp = state.pedidos.find((pedido) => {
        return pedido.id === action.id_pedido
      })
      console.log(pedido_temp)
      const productosContNew = datosNuevo.updateIn(['pedidoCont'],value => pedidocont_temp)
      const pedidoDataNew = productosContNew.updateIn(["pedido"], value => pedido_temp);
      return pedidoDataNew.toJSON();

    case GET_PEDIDOS_ADMIN:
      var pedidos_temp=[]
      action.pedidos.forEach(function(doc) {
        var data_temp=doc.data()
        data_temp['id']=doc.id
        pedidos_temp.push(data_temp)
      });
      const pedidosAdminNew = datosNuevo.updateIn(['pedidos'],value => pedidos_temp)
      return pedidosAdminNew.toJSON()

    case GET_PEDIDO_ADMIN:
      var pedidocont_temp=[]

      var pedidos_temp = state.pedidos.filter((pedido)=>{
        if(pedido.id === action.id_pedido){
          return pedido
        }
      })
      
      action.pedidoCont.forEach(function(doc) {
        var data_temp=doc.data()
        data_temp['id_base']=doc.id
        pedidocont_temp.push(data_temp)
      });

      pedidos_temp[0].contenido=pedidocont_temp

      const pedidoAdminNew = datosNuevo.updateIn(['pedido'],value =>  pedidos_temp[0])
      return pedidoAdminNew.toJSON()

    case GET_METODOS_ENVIO:
      var metodos_temp = []
      try{
        action.metodos.forEach((doc) => {
          var data_temp = doc.data()
          data_temp['id'] = doc.id
          metodos_temp.push(data_temp)
        });
      }catch(err){
        console.log(err)
      }
      const metodosEnvioNew = datosNuevo.updateIn(['metodos_envio'], value => metodos_temp)
      return metodosEnvioNew.toJSON()

    case GET_METODOS_ENVIO_ADMIN:
      var metodos_temp = []
      try {
        action.metodos.forEach((doc) => {
          var data_temp = doc.data()
          data_temp['id'] = doc.id
          metodos_temp.push(data_temp)
        });
      } catch (err) {
        console.log(err)
      }
      const metodosEnvioAdminNew = datosNuevo.updateIn(['metodos_envio_admin'], value => metodos_temp)
      return metodosEnvioAdminNew.toJSON();
    
      case GET_METODO_ADMIN:
        var metodo = state.metodos_envio_admin.filter((metodo) => {
          if (metodo.id === action.id_metodo) {
            return metodo
          }
        })
        const metodoAdminNew = datosNuevo.updateIn(['metodo'], value => metodo[0])
        return metodoAdminNew.toJSON()
      
      case ENVIA_METODO:
        console.log(action.metodo);
        //const metodoNew = datosNuevo;
        const metodoNew = datosNuevo.updateIn(["contador"], value => state.contador + 1);
        return metodoNew.toJSON();

      case PEDIDO_UPDATE_STAT:
        const statChange = datosNuevo.updateIn(["pedido","stat"], value => action.stat);
        return statChange.toJSON();

      case BORRA_METODO:
        var index = datosNuevo.get('metodos_envio_admin').findIndex(item => item.get("id") == action.id);
        const metodosDelNew = datosNuevo.deleteIn(["metodos_envio_admin", index]);
        return metodosDelNew.toJSON();

    default:
      return state
  }
}

export default pedidos


// WEBPACK FOOTER //
// ./src/reducers/pedidos.js